import { Link, useLocation } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import AppShell from "@/components/AppShell";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import StatusBadge from "@/components/StatusBadge";
import { fmtDate } from "@/lib/utils2";

export default function RequestSuccess() {
  const { state } = useLocation();
  const r = state?.request;
  return (
    <AppShell>
      <section className="max-w-2xl mx-auto px-6 py-16">
        <Card>
          <CardContent className="p-8 text-center">
            <div className="w-14 h-14 rounded-full bg-accent text-primary mx-auto flex items-center justify-center mb-4">
              <CheckCircle2 className="w-7 h-7" strokeWidth={1.75}/>
            </div>
            <h1 className="font-heading text-2xl font-semibold mb-1">Absence notification submitted</h1>
            <p className="text-sm text-muted-foreground mb-6">
              Your supervisor has been notified. We have also sent you a confirmation email.
            </p>
            {r && (
              <div className="text-left border border-border rounded-lg p-5 mb-6 space-y-2 text-sm">
                <Row label="Contractor" value={`${r.first_name} ${r.last_name}`}/>
                <Row label="Email" value={r.email}/>
                <Row label="Department" value={r.department}/>
                <Row label="Site" value={r.site || "—"}/>
                <Row label="Job role" value={r.job_role}/>
                <Row label="Supervisor" value={r.supervisor_name}/>
                <Row label="Dates" value={`${fmtDate(r.start_date)} → ${fmtDate(r.end_date)} (${r.days} day${r.days===1?"":"s"})`}/>
                <Row label="Status" value={<StatusBadge status={r.status}/>}/>
              </div>
            )}
            <div className="flex gap-3 justify-center">
              <Link to="/"><Button data-testid="back-home-btn" variant="outline">Back to home</Button></Link>
              <Link to="/request"><Button data-testid="new-request-btn">Submit another</Button></Link>
            </div>
          </CardContent>
        </Card>
      </section>
    </AppShell>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex justify-between gap-4">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium text-right">{value}</span>
    </div>
  );
}
